import React from "react";
import "./fileUpload.scss"
import { Translate } from "react-localize-redux";
import { isNullOrUndefined } from '../../store/storeFunctions';
import DeleteIcon from '../../img/icons/BBiconsOdstranit';

class FileUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = { progress: 0, fileName: "", items: "", reset: false }
    }
    render() {
        return (
            <React.Fragment>
                <div className="file-upload-wrapper">
                    <div className="input-field">
                        <input accept={this.props.accept || ".xlsx"} id="file" style={{ width: "100%" }} ref="file" type="file" name={this.props.name} className="input-file" onChange={(e) => this.onChange(e)} />
                        <label className={`input-label ${this.state.fileName ? 'w93' : 'w100'}`} htmlFor="file" >
                            <div className="upload-item">
                                {this.state.fileName}
                            </div>
                            <div className="file-label" >
                                <Translate id={this.props.text || "Common.Select"} />
                            </div>
                        </label>
                        {this.state.fileName && <DeleteIcon className="icon-centered" onClick={() => this.onResetClick()} />}
                    </div>

                    {this.props.children}
                </div>
            </React.Fragment>

        )
    }
    onResetClick = (e) => {
        this.resetProgress();
    }
    resetProgress() {
        this.setState({ progress: 0, fileName: "", items: "", reset: true });
        this.props.resetCallback && this.props.resetCallback();
        this.refs.file.value = "";
    }
    progressHandler(event) {
        if (event.lengthComputable) {
            this.setState({ progress: event.loaded / event.total * 100 })
        }
    }
    onChange(e) {
        if (this.refs.file.files.length > 0) {
            //this.setState({ value: e.target.value });
            const reader = new FileReader();
            reader.onerror = this.errorHandler;
            reader.onprogress = (e) => this.progressHandler(e, this);
            reader.onload = (e) => this.processFile(e, this);
            reader.readAsDataURL(this.refs.file.files[0]);
        }
    }
    processFile(e, that) {
        let content = e.target.result.split("base64,")[1];
        let result = {};
        result.fileName = that.refs.file.files[0].name;
        this.setState({ fileName: result.fileName, reset: false });
        result.fileBytes = content;
        result.contentType = that.refs.file.files[0].type;
        if (window._browser.isFirefox && result.fileName.toLowerCase().endsWith(".csv") && result.contentType.toLowerCase() !== "text/csv")
            result.contentType = "text/csv";
        result.reset = false;
        //result.value = this.state.value;
        that.props.callback && that.props.callback(result);
    }
    componentDidMount = () => {
        if (this.props.initialFile && this.props.initialFile.fileName !== "") {
            this.setState({ fileName: this.props.initialFile.fileName, progress: 100 })
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (!isNullOrUndefined(prevProps.initialFile) && !isNullOrUndefined(this.props.initialFile) & prevProps.initialFile.fileName !== this.props.initialFile.fileName) {
            this.setState({
                fileName: this.props.initialFile.fileName,
                progress: this.props.initialFile.fileName === "" ? 0 : 100,
                items: this.props.initialFile.fileName === "" ? "" : this.props.initialFile.items,
            })
        }

    }
}

export { FileUpload }